<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a :href="'/#/'">
            <i class="fa fa-home"></i>Home
          </a>
        </li>
        <li v-if="this.$route.params.category !== undefined" class="breadcrumb-item">
          <a :href="'/#/folderlist/'+this.listName">{{listName}}</a>
        </li>
        <li v-if="this.$route.params.category === undefined" class="breadcrumb-item active" aria-current="page">{{this.listName}}</li>
        <li v-if="this.$route.params.category !== undefined" class="breadcrumb-item active" aria-current="page">{{this.category}}</li>
      </ol>
    </nav>
    <div class="card">
      <div class="card-header">
        <div class="card-title">{{this.listName}}</div>
        <div class="card-tool">
          <select class="form-control" v-model="order" @change="sortByKey(news,'createdDateTime',order)">
            <option v-bind:value="'DESC'">Date: Latest-Earliest</option>
            <option v-bind:value="'ASC'">Date: Earliest-Latest</option>
          </select>
        </div>
      </div>
      <div class="card-body">
        <ul class="list-news">
          <li v-for="(detail,index) in news.slice(startNews,endNews)" v-bind:key="index" >
            <a v-bind:href="'/#/newsdetail/'+listName+'/'+detail.id" target="_blank">
              <div class="pic" v-bind:style="{'background-image': 'url('+getUrl(detail)+')'}"></div>
              <!-- <div v-html="getUrl(detail)"></div> -->
              <div class="con">
                <div class="title">{{detail.fields.Title}}</div>
                <div class="text">{{$moment(detail.createdDateTime).format("YYYY-MM-DD HH:mm:ss") }}</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <div class="card-footer">
        <div class="func-tool">
          <div class="pagination-num">
            {{currenPage}}/{{getTotalPage}}
            <span>Total:{{total}}</span>
          </div>
          <ul class="pagination justify-content-center">
            <li class="page-item">
              <a class="page-link" v-on:click="getLastPage(currenPage)">
                <i class="fa fa-angle-left"></i>
              </a>
            </li>
            <li class="page-item" v-for="(page,index) in getTotalPage" v-bind:key="index">
              <a class="page-link"  v-on:click="getPagination(index)">{{index+1}}</a>
            </li>
            <li class="page-item">
              <a class="page-link" v-on:click="getNextPage(currenPage)">
                <i class="fa fa-angle-right"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'NewsList',
  data: () => ({
    startNews: 0,
    endNews: 30,
    numberPerPage: 30,
    currenPage: 1,
    order: 'DESC',
    news: [],
    total: 0,
    list: '',
    site: '',
    filter: '',
    category: ''
  }),
  created () {
    this.listName = this.$route.params.name
    if (this.$route.params.category !== undefined) {
      this.category = this.$route.params.category
    }
    if (this.listName.indexOf('News') !== -1) {
      if (this.listName === 'NewsClip') {
        this.site = this.GLOBAL.sharepoint['eipsite_id']
        this.filter = this.getFilterDate(20)
      } // else if (this.listName === 'Newsletter') {
      //   this.site = this.GLOBAL.sharepoint['pilotportalsite_id']
      // } else {
      //   this.site = this.GLOBAL.sharepoint['pilotportalsite_id']
      //   this.filter = this.getFilterDate(60)
      // }
    } else {
      this.site = this.GLOBAL.sharepoint['pilotportalsite_id']
      if (this.category !== '') {
        this.filter = this.getFilterCategory(this.category)
      }
    }
    this.getList(localStorage.getItem('access_token'), this.site, this.listName, this.filter)
      .then(resp => {
        this.news = resp.data.value
        this.total = resp.data.value.length
        this.sortByKey(this.news, 'createdDateTime', 'DESC')
      })
      .catch(err => {
        console.log('err', err)
      })
  },
  methods: {
    getUrl (newsobj) {
      if (newsobj.fields.Thumbnail === undefined) {
        return 'img/img_default.jpg'
      } else {
        return newsobj.fields.Thumbnail.Url
      }
    },
    getPagination (page) {
      this.currenPage = page + 1
      this.startNews = page * this.numberPerPage
      this.endNews = (page + 1) * this.numberPerPage
    },
    getLastPage (page) {
      if (page > 1) {
        this.currenPage = page - 1
        this.startNews = (page - 2) * this.numberPerPage + 1
        this.endNews = (page - 1) * this.numberPerPage
      }
    },
    getNextPage (page) {
      if (page < this.getTotalPage) {
        this.currenPage = page + 1
        this.startNews = page * this.numberPerPage
        this.endNews = (page + 1) * this.numberPerPage
      }
    },
    sortByKey (array, key, order) {
      return array.sort((a, b) => {
        var x = a[key]
        var y = b[key]
        if (order === 'DESC') {
          return ((x < y) ? 1 : ((x > y) ? -1 : 0))
        } else if (order === 'ASC') {
          return ((x < y) ? -1 : ((x > y) ? 1 : 0))
        }
      })
    }
  },
  computed: {
    getTotalPage () {
      return Math.ceil(this.news.length / this.numberPerPage) ? Math.ceil(this.news.length / this.numberPerPage) : 1
    }
  }
}
</script>
